module.exports = [{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-kontakt-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"kontakt.json","path":"/kontakt/"},{"componentChunkName":"component---src-pages-schleiferei-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"schleiferei.json","path":"/schleiferei/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 258
// module chunks = 231608221292675